import qs from 'qs'
import history from '../../../../history'
import { Button } from '../../..'
import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { camelizeKeys } from '../../../../helpers/utils'
import { PATH_HELPERS } from '../../../../constants/navigation'
import { selectFilter } from '../../../../store/selectors/filters'
import { selectCustomerId } from '../../../../store/selectors/customerProfile'
import { RootState } from '../../../../types/rootState'
import styles from './FiltersFooterButtons.module.scss'

export const MSG = defineMessages({
  cancel: {
    id: 'General.cancel',
    defaultMessage: 'Cancel'
  },
  reset: {
    id: 'HomeSearch.listings.filters.reset',
    defaultMessage: 'Reset filters'
  },
  apply: {
    id: 'General.apply',
    defaultMessage: 'Apply'
  }
})

export interface FiltersFooterButtonsProps {
  onClose: () => void
}

export const FiltersFooterButtons = ({ onClose }: FiltersFooterButtonsProps) => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const customerId = useSelector(selectCustomerId)
  const isPublic = useSelector<RootState, boolean>(state => state.auth.isPublic)
  const queryParams = camelizeKeys(
    qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
  )

  const resetFilters = () => {
    const listingsUrl = PATH_HELPERS.listings.buildPath(
      customerId,
      queryParams?.placeId ? 'place_id' : filters?.location?.level,
      queryParams?.placeId ? queryParams?.placeId : filters?.location?.name,
      {
        statuses: ['Active', 'Coming Soon']
      }
    )
    const publicListingsUrl = PATH_HELPERS.publicListings.buildPath(
      queryParams?.placeId ? 'place_id' : filters?.location?.level,
      queryParams?.placeId ? queryParams?.placeId : filters?.location?.name,
      {
        statuses: ['Active', 'Coming Soon']
      }
    )

    history.push(isPublic ? publicListingsUrl : listingsUrl)

    onClose()
    document.getElementById('list-top')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  return (
    <div className={styles.buttons}>
      <Button onClick={resetFilters} minimal danger type='button'>
        {intl.formatMessage(MSG.reset)}
      </Button>
      <div className={styles.buttonsRight}>
        <Button onClick={onClose} type='button'>
          {intl.formatMessage(MSG.cancel)}
        </Button>
        <Button primary type='submit'>
          {intl.formatMessage(MSG.apply)}
        </Button>
      </div>
    </div>
  )
}
